// config.js

const bizIcon = 'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/19MS4yR9l69jyEI8PaA0/media/674207da1cefe260d37f5672.png';
const myBizIcon = 'https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg';
const imageOne = "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/19MS4yR9l69jyEI8PaA0/media/138bb885-8386-4a10-9f4b-92e872bd061b.webp";
const imageTwo = "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/19MS4yR9l69jyEI8PaA0/media/6740c4b7e7467676111b2eb1.png";
const imageThree = "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/19MS4yR9l69jyEI8PaA0/media/1cddb4d7-6499-4b61-ad74-7afdbe178aaf.jpeg";
const imageFour = "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/19MS4yR9l69jyEI8PaA0/media/6740c4b77776d587518f8f6f.png";
const imageFive = "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/19MS4yR9l69jyEI8PaA0/media/6745b716a0500f7c03e9e351.jpeg";

const redirectLink = "www.elsometaconstructionllc.com";
export const siteConfig = {
  title: "El Someta Construction LLC",
  metaDescription: "El Someta Construction LLC",
  theme: {
    primaryColor: "blue-600",
    secondaryColor: "gray-900",
    accentColor: "text-blue-600"
  },
  logo: {
    src: bizIcon,
    alt: "El Someta Construction LLC",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "El Someta Construction LLC",
    headline: "Your Trusted Construction Firm in Georgia",
    address: "114 Hidden Valley Dr, Lawrenceville, Georgia, 30044, United States",
    description: `
        El Someta Construction LLC is dedicated to delivering high-quality construction solutions for residential, commercial, and industrial projects across Georgia. With a commitment to excellence, attention to detail, and client satisfaction, we turn your vision into reality. Let us build your dream spaces with precision and professionalism.`,
  },  
  images: {
    business: {
      src: imageOne,
      alt: "Your Trusted Construction Firm in Georgia",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
        description: 
            "Comprehensive Services: Whether it’s a home remodel or a commercial build, El Someta Construction LLC handles a wide range of carpentry and construction needs with expertise and care.",
    },
    {
        description: 
            "Local & Trusted: Proudly serving the Lawrenceville, Duluth, and Atlanta areas, we are dedicated to our community and building lasting relationships with every client.",
    },
    {
        description: 
            "Quality You Can Count On: Using top-tier materials and exceptional craftsmanship, we ensure every project exceeds your expectations and stands the test of time.",
    },
],
  services: {
    sectionTitle: "Services",
    description: 
    "El Someta Construction LLC is proud to serve the Lawrenceville, Duluth, and Atlanta areas, offering expert construction services tailored to meet the unique needs of each client. Whether you're looking for home renovations, commercial builds, or custom carpentry, our dedication to quality craftsmanship ensures exceptional result",
    callouts: [
        {
          name: 'Carpentry',
          description: 
          "We specialize in carpentry work and can handle a wide range of projects, from custom cabinetry to structural woodwork. Just let us know the scope of your project, and we'll bring it to life with precision and expertise.",
          imageSrc: imageTwo,
          imageAlt: 'Custom carpentry project in Georgia',
        },
        {
          name: 'Painting',
          description: 
          "From refreshing your interiors to complete exterior painting services, our team provides high-quality, durable, and beautiful finishes tailored to your preferences.",
          imageSrc: imageThree,
          imageAlt: 'Professional painting project in Georgia',
        },
        {
          name: 'Countertops',
          description: 
          "Enhance your kitchen or bathroom with stunning countertops installed with precision and care, using only the finest materials for a lasting impression.",
          imageSrc: imageFour,
          imageAlt: 'Beautifully installed countertop in Georgia',
        },
    ],
    otherServices: [
      "Bathroom",
      "Cabinets",
      "Drywall",
      "Electricity",
      "Flooring",
      "Kitchen",
      "Tile",
      "Trim",
    ]
  },  
  about: {
    sectionTitle: "About",
    description:   
    "Welcome to El Someta Construction LLC! With over 7 years of experience, we are a trusted team of construction professionals serving Lawrenceville, Duluth, Atlanta, Marietta, and surrounding areas. Specializing in residential and commercial projects, we pride ourselves on delivering top-quality craftsmanship that exceeds expectations. From home renovations to custom woodworking and business builds, our commitment to excellence ensures durable and beautiful results that stand the test of time.",
    image: {
      src: imageFive,
      alt: "El Someta Construction LLC team at work in Georgia",
      width: 1200,
      height: 800
    }
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "114 Hidden Valley Dr, Lawrenceville, Georgia, 30044, United States",
    googleMapsEmbedUrl: 
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3272.329463918394!2d-84.06729178491963!3d33.93660977910917!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5b59852d97d8f%3A0xabcdef123456789!2s114%20Hidden%20Valley%20Dr%2C%20Lawrenceville%2C%20GA%2030044%2C%20USA!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus",
    subCategories: [
      { 
        name: 'Apple Maps', 
        url: 'https://maps.apple.com/?address=114%20Hidden%20Valley%20Dr,%20Lawrenceville,%20GA%2030044&ll=33.936610,-84.067292&q=114%20Hidden%20Valley%20Dr',
      },
      { 
        name: 'Bing Maps', 
        url: 'https://www.bing.com/maps?q=114+Hidden+Valley+Dr,+Lawrenceville,+GA+30044&FORM=HDRSC6',
      },
      { 
        name: 'Google Earth', 
        url: 'https://earth.google.com/web/search/114+Hidden+Valley+Dr,+Lawrenceville,+GA+30044/@33.936610,-84.067292,15a,814.57589625d,35y,0h,0t,0r',
      },
      { 
        name: 'Google Maps', 
        url: 'https://www.google.com/maps/place/114+Hidden+Valley+Dr,+Lawrenceville,+GA+30044/@33.936610,-84.067292,15z',
      }
    ]
  },
  contact: {
    sectionTitle: "Schedule a Call with Us",
    description: "Get in touch with El Someta Construction LLC to discuss your next construction project or renovation needs. From home remodels to commercial builds, our team is here to provide expert advice, top-notch craftsmanship, and personalized service to bring your vision to life.",
    socialLinks: {
      facebook: redirectLink,     
      instagram: redirectLink,     
      twitter: redirectLink,     
      linkedin: redirectLink,     
      youtube: redirectLink,     
    },
    contactNumbers: [
      "Mobile: (463) 206-5609",
    ],
    logo: bizIcon,
    emailRecipient: "info@elsometaconstructionllc.com"
  },
  footer: {
    bizSolutionsLogo: myBizIcon
  }
};


